import {
    faArrowDown,
    faArrowUp,
    faFileSignature,
    faGripLines,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Dropdown, ButtonGroup, Button } from "react-bootstrap";
import { useEditarConfigDeEnvelopeContext } from "../../..";
import IconOrSpinner from "../../../../../../../Components/Utils/IconOrSpinner";
import {
    DeletarConfigEnvelopeDocumentoController,
    InserirConfigEnvelopeDocumentoController,
} from "../../../../../../../Controllers/Geral/ConfigEnvelope/ConfigEnvelopeDocumento/ConfigEnvelopeDocumentoControllers";
import useAsyncCallback from "../../../../../../../hooks/useAsyncCallback";
import { IInserirConfigEnvelopeDocumento } from "../../../../../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeDocumento/ConfigEnvelopeDocumentoInterfaces";
import MenuSelecaoDeRubricas from "./MenuSelecaoDeRubricas";

interface IDocumentoASerInseridoNaConfiguracaoProps {
    descricao: string;
    tipoDocumento?: string;
    configEnvelopeDocumentoBase: IInserirConfigEnvelopeDocumento;
    idVinculado?: number;
    updateList: () => void;
    draggable?: boolean;
    mostrarRubricas?: boolean;
}

export default function DocumentoASerInseridoNaConfiguracao(
    props: IDocumentoASerInseridoNaConfiguracaoProps
) {
    const { execute: vincularEmConfiguracao, loading: vinculando } =
        useAsyncCallback(InserirConfigEnvelopeDocumentoController);

    const { execute: desvincularEmConfiguracao, loading: desvinculando } =
        useAsyncCallback(DeletarConfigEnvelopeDocumentoController);

    const {
        documentosConfigEnvelope: { lst: lstDocumentosConfigEnvelope },
        destinatariosConfigEnvelope: { lst: lstDestinatariosConfigEnvelope },
    } = useEditarConfigDeEnvelopeContext();

    const lstRubricas = props.mostrarRubricas
        ? lstDocumentosConfigEnvelope.find(
              (d) =>
                  d.ID_ENVELOPE_DOCUSIGN_CONFIG_DOCUMENTO === props.idVinculado
          )?.LISTA_ID_DESTINATARIO ?? []
        : [];

    function handleVincularOuDesvincularButtonClick() {
        let promise: Promise<void>;
        if (props.idVinculado) {
            promise = desvincularEmConfiguracao(props.idVinculado);
        } else {
            promise = vincularEmConfiguracao({
                ...props.configEnvelopeDocumentoBase,
            });
        }
        promise.then(props.updateList);
    }

    const loading = vinculando || desvinculando;
    const buttonVariant = props.idVinculado
        ? "outline-danger"
        : "outline-success";

    return (
        <div className="d-flex justify-content-between align-items-center p-4 border-y g-2 w-100">
            <div>
                <h6 className="m-0">
                    {props.draggable && (
                        <FontAwesomeIcon className="mr-2" icon={faGripLines} />
                    )}
                    {props.descricao}
                </h6>
                <div>{props.tipoDocumento}</div>
                <div className="d-flex flex-wrap g-2 align-items-center">
                    {props.mostrarRubricas &&
                        lstRubricas.map((rubrica) => {
                            const destinatario =
                                lstDestinatariosConfigEnvelope.find(
                                    (d) =>
                                        d.ID_ENVELOPE_DOCUSIGN_CONFIG_DESTINATARIO ===
                                        rubrica
                                );
                            if (destinatario)
                                return (
                                    <span
                                        key={rubrica}
                                        className="label label-inline label-light-info"
                                    >
                                        <FontAwesomeIcon
                                            className="mr-2"
                                            icon={faFileSignature}
                                        />
                                        {destinatario.DS_DESTINATARIO}
                                    </span>
                                );
                            else return <React.Fragment key={rubrica} />;
                        })}
                </div>
            </div>
            <Dropdown as={ButtonGroup}>
                <Button
                    variant={buttonVariant}
                    onClick={handleVincularOuDesvincularButtonClick}
                    disabled={loading}
                >
                    <IconOrSpinner
                        icon={props.idVinculado ? faArrowDown : faArrowUp}
                        loading={loading}
                        loadingSize="sm"
                    />
                </Button>

                <Dropdown.Toggle split variant={buttonVariant} />

                <MenuSelecaoDeRubricas
                    descricao={props.descricao}
                    idVinculado={props.idVinculado}
                    configEnvelopeDocumentoBase={
                        props.configEnvelopeDocumentoBase
                    }
                    updateList={props.updateList}
                />
            </Dropdown>
        </div>
    );
}
